import * as React from "react";
import {
  useDispatch,
  useMappedState
} from "redux-react-hook";

import { useNotificationsApi } from "src/core/notifications/api/notifications.api";
import { setNotification } from "src/core/notifications/store/notifications.actions";
import { IStore } from "src/core/shared/store";
import { setGlobalError } from "src/core/shared/store/global/global.actions";

import { INotification } from "../api/notifications.api";

const useNotification = (notificationId: number) => {
  const [ isLoading, setLoading ] = React.useState(true);
  const dispatch = useDispatch();
  const { notification } = useMappedState(({ notifications }: IStore) => notifications);
  const [ getNotificationResponse, getNotification ] = useNotificationsApi("GET_NOTIFICATION");

  const setCurrentNotification = React.useCallback((notification: INotification | null) => {
    dispatch(setNotification(notification));
  }, [ dispatch ]);

  React.useEffect(() => {
    if (!notification || notification.id !== notificationId) {
      if (notification) {
        setCurrentNotification(null);
      }

      getNotification(notificationId);
    } else {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    if (getNotificationResponse.data) {
      setCurrentNotification(getNotificationResponse.data);
      setLoading(false);
    }

    if (getNotificationResponse.error) {
      dispatch(setGlobalError(getNotificationResponse.error));
    }
  }, [
    dispatch,
    getNotificationResponse,
    setCurrentNotification
  ]);

  return {
    isLoading,
    notification,
    getNotification,
    setCurrentNotification
  };
};

export default useNotification;
